import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import {getAdvertisers} from "../actions/advertisersActions";
import {connect} from "react-redux";
import Spinner from "./Spinner";
import MenuItem from "@mui/material/MenuItem";


class CloneIODialog extends React.Component {

  componentDidMount() {
    document.title = 'GALILEO - Advertisers';
    const { dispatch } = this.props;
    dispatch(getAdvertisers());
  }

  handleAdvertiserChange = (evt) => {
    const { advertisers, onAdvertiserChange } = this.props;
    const chosenAdvertiser = advertisers.find(a => a.id === evt.target.value);
    onAdvertiserChange(chosenAdvertiser);
  }

  cancelClicked = () => {
    console.log('Cancelled');
    this.props.setCloneDialogFalse();
  }

  render() {
    const {
      advertiser,
      advertisers,
      isFetchingAdvertisers,
      cloneIOAgencyId,
      cloneIOAgencyName,
      onCloneIOChange,
      onCloneOrder,
      orderType,
    } = this.props;

    const thisAdvertiser = (advertisers && advertisers.length > 0) ? advertisers.find(a => a.name === advertiser): {};
    if (advertisers && advertisers.length > 0) {
      advertisers.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }

    return (
      <div>
        {isFetchingAdvertisers && <Spinner />}
        {!isFetchingAdvertisers && advertisers && (
        <Dialog
          aria-labelledby="clone-io-dialog-title"
          aria-describedby="clone-io-dialog-description"
          open
        >
          <DialogTitle id="alert-title">
            <Typography variant="h6" id="modal-title">
            Clone IO
            </Typography>
            <Typography variant="subtitle1" id="clone-io-modal-description">
              <p>Advertiser can be changed here for the cloned order.</p>
              <p>Agency IO Name (and ID if required) must be unique. Please provide new values for your new IO.</p>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <TextField
              variant="standard"
              fullWidth
              select
              name={thisAdvertiser.name}
              value={thisAdvertiser.id}
              onChange={this.handleAdvertiserChange}
              label="Advertiser"
              margin="normal">
              {advertisers.map(adv => (
                <MenuItem key={adv.name} value={adv.id}>
                  {adv.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              variant="standard"
              fullWidth
              id="cloneIOAgencyName"
              value={cloneIOAgencyName}
              onChange={onCloneIOChange}
              label="New Agency IO Name"
              margin="normal" />
            {orderType !=='Programmatic' && (
            <TextField
              variant="standard"
              fullWidth
              id="cloneIOAgencyId"
              value={cloneIOAgencyId}
              onChange={onCloneIOChange}
              label="New Agency IO ID"
              margin="normal" />
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.cancelClicked}
            >Cancel
            </Button>
            <Button
              color="primary"
              disabled={(orderType !=='Programmatic' && (!cloneIOAgencyId || !cloneIOAgencyId.length)) ||
            !cloneIOAgencyName || !cloneIOAgencyName.length}
              onClick={onCloneOrder}
            >Clone
            </Button>
          </DialogActions>
        </Dialog> ) }
      </div>
    );
  }
}

CloneIODialog.propTypes = {
  onCloneOrder: PropTypes.func.isRequired,
  onCancelClone: PropTypes.func.isRequired,
  onCloneIOChange: PropTypes.func.isRequired,
  onAdvertiserChange: PropTypes.func.isRequired,
  orderType: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  const { advertisersRequest, advertiserRequest } = state;
  return {
    advertisers: advertisersRequest.advertisers,
    selectedAdvertiser: advertiserRequest.advertiser,
    isFetchingAdvertisers: advertisersRequest.isFetching,
    isFetching: advertiserRequest.isFetching,
  }
};

export default connect(mapStateToProps)(CloneIODialog);
